import { Box, styled } from "@mui/material";
import React from "react";

const ResizeHandleContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "position",
})<{ position?: "left" | "right" }>`
  position: absolute;
  top: 0;
  ${(props) => (props.position === "left" ? "left: 0;" : "right: 0;")}
  width: 4px;
  height: 100%;
  cursor: col-resize;
  background: transparent;
  z-index: 100;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #008069;
  }

  &:active {
    background-color: #006b5a;
  }

  /* Indicador visual quando está sendo arrastado */
  &[data-resizing="true"] {
    background-color: #008069;
    width: 4px;
  }

  @media (max-width: 600px) {
    display: none; /* Desabilitar redimensionamento em mobile */
  }
`;

interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
  onDoubleClick?: (e: React.MouseEvent) => void;
  isResizing?: boolean;
  position?: "left" | "right";
}

const ResizeHandle: React.FC<ResizeHandleProps> = ({
  onMouseDown,
  onDoubleClick,
  isResizing = false,
  position = "right",
}) => {
  return (
    <ResizeHandleContainer
      position={position}
      data-resizing={isResizing}
      onMouseDown={onMouseDown}
      onDoubleClick={onDoubleClick}
      sx={{
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
      }}
    />
  );
};

export default ResizeHandle;
